import {ChangeDetectorRef, Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ContactApiService} from '../../../../../projects/api/src/contact/contact-api.service';
import {ContactInfo} from '../../../../../projects/api/src/contact/contact-info.model';
import {BrandingApiService} from '../../../../../projects/api/src/branding/branding-api.service';
import {CommonModule} from '@angular/common';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
    imports: [CommonModule],
  standalone: true,
  selector: 'app-logo-atommind',
  templateUrl: './logo-atommind.component.html',
  styleUrls: ['./logo-atommind.component.scss']
})
export class LogoAtommindComponent implements OnInit, OnDestroy {

  showDefaultLogo = false;
  public logoHref = '#';
  public logoImageUrl = null;
  private contactSubscription;
  private contactInfo: ContactInfo;
  private translate = inject(TranslateService);
  private langChangeSub: Subscription;
  private cdRef = inject(ChangeDetectorRef);
  currentLang = this.translate.currentLang;

  constructor(private contactApi: ContactApiService, private brandingApi: BrandingApiService) {
  }


  ngOnInit() {
    this.contactSubscription = this.contactApi.getContactInfo()
      .subscribe(data => {
        this.contactInfo = data;
        this.setLogoHref();
      });
    this.setDefaultLogoImage();

    this.langChangeSub = this.translate.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang;
      this.cdRef.detectChanges();
    });
  }

  private setLogoHref() {
    if (this.contactInfo && this.contactInfo.webSite && this.contactInfo.webSite.trim().length > 0) {
      this.logoHref = this.contactInfo.webSite.indexOf('http') >= 0 ?
                      this.contactInfo.webSite :
                      'https://' + this.contactInfo.webSite;
    }
  }

  setDefaultLogoImage() {
    this.brandingApi.isExist('loginScreenLogo').subscribe(data => {
        if (data) {
          this.logoImageUrl = this.brandingApi.makeImageUrl('loginScreenLogo');
        } else {
        }
      }, error => {
        console.log(error);
      }
    );
  }

  ngOnDestroy(): void {
    this.contactSubscription.unsubscribe();
  }
}
